import { useParams } from 'react-router-dom'
import { buildErrorMessage } from '@constants'
import { AxiosError } from 'axios'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSnackbar } from '@ui/snackbar'
import { getProjectFiles } from '@queries'
import { saveProjectFileItem } from '@mutations'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useUploadProjectFile = <T extends Record<string, any> = Record<string, any>>(
  rootGuid: string,
  options?: {
    showSuccessMessage?: boolean
  },
) => {
  const { projectId } = useParams()
  const { enqueueSnackbar } = useSnackbar()
  const queryClient = useQueryClient()

  return useMutation(
    async (data: FileItem<T> & { file: File; pdfPage?: number }) => {
      return await saveProjectFileItem.request(projectId as string, rootGuid, data)
    },
    {
      onSuccess: (data: FileItem<T>) => {
        const queryKey = getProjectFiles.getKey(projectId, rootGuid)
        const currentData = queryClient.getQueryData(queryKey) as FilesResult | undefined
        queryClient.setQueryData(queryKey, {
          files: [...(currentData?.files ?? []), data],
          sections: currentData?.sections ?? [],
        })

        if (options?.showSuccessMessage) {
          enqueueSnackbar('Datei erfolgreich hochgeladen', { variant: 'success' })
        }
      },
      onError: (error: AxiosError) => {
        enqueueSnackbar(buildErrorMessage(error, 'Fehler beim Hochladen der Datei'), {
          variant: 'error',
        })
      },
    },
  )
}

export default useUploadProjectFile
